import React from 'react';

import Loadable from 'react-loadable';
import { type RouteComponentProps } from 'react-router-dom';

const LazyTeamEmbed = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_team-embed-page" */ './main'
		),
	loading: () => null,
});
LazyTeamEmbed.displayName = 'lazy(LazyTeamEmbed)';

const TeamEmbedRoute = ({
	match,
}: Pick<RouteComponentProps<{ teamId: string }>, 'match'>): React.JSX.Element => {
	return <LazyTeamEmbed teamId={match.params.teamId} />;
};

export default TeamEmbedRoute;
